"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNames = exports.FormV2 = void 0;
var _react = _interopRequireWildcard(require("react"));
var _socialLogin = require("./socialLogin");
var _useLogin2 = require("./useLogin");
require("./styles.scss");
var _Box = _interopRequireDefault(require("schoolUiComponents/basic/Box"));
var _Button = _interopRequireDefault(require("schoolUiComponents/basic/Button"));
var _Text = _interopRequireDefault(require("schoolUiComponents/basic/Text"));
var _FlexBox = _interopRequireDefault(require("schoolUiComponents/basic/Box/FlexBox"));
var _Input = _interopRequireDefault(require("schoolUiComponents/basic/Input"));
var _colors = require("baseStyles/enums/colors");
var _types = require("schoolUiComponents/basic/Box/FlexBox/types");
var _types2 = require("schoolUiComponents/basic/Input/types");
var _passwordIcon = _interopRequireDefault(require("./assets/passwordIcon.svg"));
var _passwordShowIcon = _interopRequireDefault(require("./assets/passwordShowIcon.svg"));
var _style = _interopRequireDefault(require("./style"));
var _events = require("../../ptlSignup/events");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PageNames = exports.PageNames = /*#__PURE__*/function (PageNames) {
  PageNames["PTL_LOGIN"] = "ptlParentLoginScreen";
  PageNames["PTL_OTP_LOGIN"] = "loginViaOtpByClassroomLinkedParent";
  return PageNames;
}({}); // @ts-ignore
window.ptlLoginEventProps = {
  pageName: PageNames.PTL_LOGIN,
  otpEntered: false
};
var FormV2 = exports.FormV2 = function FormV2(_ref) {
  var _ref$showOTPLoginOpti = _ref.showOTPLoginOption,
    showOTPLoginOption = _ref$showOTPLoginOpti === void 0 ? true : _ref$showOTPLoginOpti,
    _ref$primaryInputLabe = _ref.primaryInputLabel,
    primaryInputLabel = _ref$primaryInputLabe === void 0 ? "Email" : _ref$primaryInputLabe,
    _ref$showForgotPasswo = _ref.showForgotPassword,
    showForgotPassword = _ref$showForgotPasswo === void 0 ? true : _ref$showForgotPasswo,
    _ref$showSocialLogin = _ref.showSocialLogin,
    showSocialLogin = _ref$showSocialLogin === void 0 ? true : _ref$showSocialLogin,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? null : _ref$source,
    _ref$sendEvent = _ref.sendEvent,
    sendEvent = _ref$sendEvent === void 0 ? function (clickedOn) {} : _ref$sendEvent;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    passwordVisibility = _useState2[0],
    togglePasswordVisibility = _useState2[1];
  var _useLogin = (0, _useLogin2.useLogin)({
      primaryInputLabel: primaryInputLabel,
      showSocialLogin: showSocialLogin,
      sendEvent: sendEvent,
      source: source,
      isPtlFlow: true
    }),
    handleLogin = _useLogin.handleLogin,
    otpSent = _useLogin.otpSent,
    setOTPSent = _useLogin.setOTPSent,
    setIntentId = _useLogin.setIntentId,
    email = _useLogin.email,
    setEmail = _useLogin.setEmail,
    error = _useLogin.error,
    setError = _useLogin.setError,
    otpLogin = _useLogin.otpLogin,
    password = _useLogin.password,
    setPassword = _useLogin.setPassword,
    timer = _useLogin.timer,
    sendOTP = _useLogin.sendOTP,
    otp = _useLogin.otp,
    setOTP = _useLogin.setOTP,
    showResendSuccessMsg = _useLogin.showResendSuccessMsg,
    setOTPLogin = _useLogin.setOTPLogin,
    socialLoginEnabled = _useLogin.socialLoginEnabled,
    maskedEmail = _useLogin.maskedEmail,
    params = _useLogin.params,
    emailEvents = _useLogin.emailEvents,
    setEmailEvents = _useLogin.setEmailEvents,
    passwordEvents = _useLogin.passwordEvents,
    setPasswordEvents = _useLogin.setPasswordEvents,
    setFromPage = _useLogin.setFromPage,
    referralData = _useLogin.referralData,
    handleForgotPassword = _useLogin.handleForgotPassword;
  var styles = (0, _style["default"])();
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleLogin,
    autoComplete: "on",
    style: {
      backgroundColor: _colors.Colors.WHITE
    },
    "data-sentry-component": "FormV2",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-form-v2"
  }, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    width: styles.mainBox.width,
    gap: 17,
    alignStart: true,
    column: true,
    "data-sentry-element": "FlexBox",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    fullWidth: true,
    "data-sentry-element": "Box",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    value: email,
    placeholder: primaryInputLabel,
    autoFocus: true,
    tabIndex: 1,
    disabled: otpSent || maskedEmail,
    onChange: function onChange(e) {
      if (!(otpSent || maskedEmail)) {
        var _e$target;
        error && setError(null);
        setEmail((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
        if (!emailEvents.pasted && !emailEvents.typed) {
          setEmailEvents(_objectSpread(_objectSpread({}, emailEvents), {}, {
            typed: true
          }));
          (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
            clickedOn: "Email input box",
            interactionDetails: "Started typing"
          }, referralData));
        }
      }
    },
    name: "sl-user-login-email",
    "data-test-id": "user-login",
    color: !(email !== null && email !== void 0 && email.length) || maskedEmail || otpSent ? _colors.Colors.CONTENT_TEXT_TERTIARY : _colors.Colors.DARK_GREY,
    hasError: error,
    width: styles.mainBox.width,
    padding: "16px 24px",
    customPlaceholder: true,
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 600,
    onClick: function onClick() {
      return (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Email input box",
        interactionDetails: ""
      }, referralData));
    },
    onPaste: function onPaste() {
      setEmailEvents(_objectSpread(_objectSpread({}, emailEvents), {}, {
        pasted: true
      }));
      (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Email input box",
        interactionDetails: "Copy pasted"
      }, referralData));
    },
    "data-sentry-element": "Input",
    "data-sentry-source-file": "formV2.tsx"
  }), maskedEmail && !(params !== null && params !== void 0 && params.user_id) && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    justifyContent: _types.FlexProps.JustifyContent.FLEX_END,
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    onClick: function onClick() {
      if (maskedEmail) {
        var searchParams = new URLSearchParams();
        Object.keys(params || {}).forEach(function (key) {
          return searchParams.append(key, params === null || params === void 0 ? void 0 : params[key]);
        });
        window.location.href = "/ptl-setup?".concat(searchParams);
      }
      sendEvent("Change email");
      (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
        clickedOn: "Change email",
        interactionDetails: "",
        otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
      }, referralData));
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].NORMAL, {
    emphasis: true,
    noUnderline: true,
    cta: true
  }, "Change email"))), otpLogin && !otpSent && error && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.DARK_RED_2,
    fullWidth: true,
    lines: 3
  }, error))), !otpLogin && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    value: password,
    type: passwordVisibility ? _types2.InputTypes.TEXT : _types2.InputTypes.PASSWORD,
    placeholder: "Password",
    tabIndex: 2,
    onChange: function onChange(e) {
      var _e$target2;
      error && setError(null);
      if (!passwordEvents.pasted && !passwordEvents.typed) {
        setPasswordEvents(_objectSpread(_objectSpread({}, passwordEvents), {}, {
          typed: true
        }));
        (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
          clickedOn: "Password input box",
          interactionDetails: "Started typing"
        }, referralData));
      }
      setPassword((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value);
    },
    name: "sl-user-login-password",
    "data-test-id": "user-password",
    color: !(password !== null && password !== void 0 && password.length) ? _colors.Colors.CONTENT_TEXT_TERTIARY : _colors.Colors.DARK_GREY,
    hasError: error,
    width: styles.mainBox.width,
    padding: "16px 24px",
    customPlaceholder: true,
    icon: /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      height: 24,
      onClick: function onClick() {
        return togglePasswordVisibility(function (visible) {
          return !visible;
        });
      }
    }, passwordVisibility ? /*#__PURE__*/_react["default"].createElement(_passwordShowIcon["default"], null) : /*#__PURE__*/_react["default"].createElement(_passwordIcon["default"], null)),
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 600,
    onClick: function onClick() {
      return (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Password input box",
        interactionDetails: ""
      }, referralData));
    },
    onPaste: function onPaste() {
      setPasswordEvents(_objectSpread(_objectSpread({}, passwordEvents), {}, {
        pasted: true
      }));
      (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Password input box",
        interactionDetails: "Copy pasted"
      }, referralData));
    }
  }), showForgotPassword && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    tabIndex: 4,
    justifyContent: _types.FlexProps.JustifyContent.FLEX_END,
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    onClick: function onClick() {
      (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
        clickedOn: "Forgot Password",
        interactionDetails: ""
      }, referralData));
      handleForgotPassword === null || handleForgotPassword === void 0 || handleForgotPassword();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].NORMAL, {
    emphasis: true,
    noUnderline: true,
    cta: true
  }, "Forgot password?"))), error && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.DARK_RED_2,
    fullWidth: true,
    lines: 3
  }, error))), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    gap: 8,
    fullWidth: true,
    column: true,
    alignStart: true
  }, otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.CONTENT_TEXT_SECONDARY
  }, "We\u2019ve sent a verification code to the email above."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "otp-text"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: "otp",
    maxLength: 6,
    autoComplete: "off",
    onChange: function onChange(_ref2) {
      var _target$value;
      var target = _ref2.target;
      error && setError(null);
      setOTP(target === null || target === void 0 ? void 0 : target.value);
      // @ts-ignore
      window.ptlLoginEventProps.otpEntered = (target === null || target === void 0 || (_target$value = target.value) === null || _target$value === void 0 ? void 0 : _target$value.length) === 6;
    },
    autoFocus: true,
    value: otp,
    "data-test-id": "otp-input",
    onClick: function onClick() {
      return (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
        clickedOn: "OTP input",
        interactionDetails: "",
        otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
      }, referralData));
    }
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: "autocomplete",
    type: "email",
    readOnly: true
  }), ["", "", "", "", "", ""].map(function (_char, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "otp-box"
    }, (otp === null || otp === void 0 ? void 0 : otp[index]) || "");
  })), otpSent && /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    className: "".concat(timer ? "disabled otp-timer" : ""),
    onClick: timer > 0 ? null : function () {
      return sendOTP();
    },
    justifyContent: _types.FlexProps.JustifyContent.FLEX_END,
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].NORMAL, {
    emphasis: true,
    opacity: timer > 0 ? 0.4 : 1,
    noUnderline: true,
    cta: true
  }, "Resend code ", timer ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", "in ", /*#__PURE__*/_react["default"].createElement("strong", null, timer, "s")) : "")), error && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: "0 24px",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    color: _colors.Colors.DARK_RED_2,
    fullWidth: true,
    lines: 3
  }, error)), showResendSuccessMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: "info success"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconCheck"
  }), " A new verification code has been sent.")), /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    gap: 16,
    column: true,
    fullWidth: true,
    "data-sentry-element": "FlexBox",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    primary: true,
    onClick: handleLogin,
    "data-test-id": "login-submit-button",
    tabIndex: 3,
    disabled: !(email !== null && email !== void 0 && email.length),
    "data-sentry-element": "Button",
    "data-sentry-source-file": "formV2.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].H4, {
    color: _colors.Colors.WHITE,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "formV2.tsx"
  }, otpLogin ? "Submit" : "Log in")), showOTPLoginOption && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    bordered: true,
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      setOTPLogin(function (value) {
        return !value;
      });
      setError(null);
      if (otpLogin) {
        // @ts-ignore
        window.ptlLoginEventProps.pageName = PageNames.PTL_OTP_LOGIN;
        setFromPage("Parent login via otp verification screen");
        (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
          clickedOn: "Login with password",
          interactionDetails: "",
          otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
        }, referralData));
      } else {
        // @ts-ignore
        window.ptlLoginEventProps.pageName = PageNames.PTL_LOGIN;
        setFromPage("Parent login screen");
        (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
          clickedOn: "Log in via verification code",
          interactionDetails: ""
        }, referralData));
      }
    },
    "data-test-id": "verification-code-hypertext"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"].H4, {
    color: _colors.Colors.PURE_PURPLE,
    hoverColor: _colors.Colors.NAVY_BLUE
  }, "Login via ", otpLogin ? "password" : "verification code"))), otpLogin && otpSent && /*#__PURE__*/_react["default"].createElement(_Text["default"].SMALL, {
    fullWidth: true,
    lines: 3,
    color: _colors.Colors.CONTENT_TEXT_TERTIARY
  }, "If you are not seeing the email, the email may have landed in your spam folder, or your account may be associated with a different email.")), socialLoginEnabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "or-bar"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "or-bar-text"
  }, "or Login with")), /*#__PURE__*/_react["default"].createElement(_socialLogin.SocialLogin, null))));
};